/* oxlint-disable no-underscore-dangle */
/**
 * Config resolved at RUNTIME (build-once → promote dev→staging→prod strategy).
 *
 * - Web/PWA: the container injects `window.__APP_CONFIG__` via `/config.js` (generated
 *   by the nginx entrypoint from environment variables at startup). One image
 *   serves every environment; only the container env changes.
 * - Tauri (desktop/mobile): there is no `/config.js`; it falls back to the baked-in
 *   `import.meta.env.VITE_*` values (build-time) → behavior unchanged.
 * - Local dev: likewise (import.meta.env from apps/web/.env) or a localhost fallback.
 */
interface AppRuntimeConfig {
  SERVER_URL?: string;
  POWERSYNC_URL?: string;
}

const runtime: AppRuntimeConfig =
  (globalThis as typeof globalThis & { __APP_CONFIG__?: AppRuntimeConfig }).__APP_CONFIG__ ?? {};

/**
 * First value ACTUALLY present. Bare `??` is not enough: the entrypoint
 * writes `"CLAVE": ""` for every env the container does not define, and an empty
 * string is not nullish → it would beat the default and leave, for example, a
 * base URL empty. Here "not configured" and "empty" are the same thing.
 */
function firstConfigured(...values: (string | undefined)[]): string | undefined {
  return values.find((v) => v !== undefined && v.trim() !== "")?.trim();
}

/** Backend base (auth/api/server). */
export const SERVER_URL: string =
  firstConfigured(
    runtime.SERVER_URL,
    import.meta.env.VITE_SERVER_URL,
    import.meta.env.VITE_API_URL,
  ) ?? "http://localhost:3333";

/** PowerSync service endpoint. */
export const POWERSYNC_URL: string =
  firstConfigured(runtime.POWERSYNC_URL, import.meta.env.VITE_POWERSYNC_URL) ??
  "http://localhost:8085";
